import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

export const useAutoCompleteLanguages = (input?: string) =>
  useAlgoliaAutoComplete(LanguageIndex, input).map(({ language }) => ({
    label: language,
    value: language,
  }));

const LanguageIndex = makeAlgoliaIndex(
  'Languages',
  createDetailedValidator<{ language: string }>(),
);
